import React from "react";
import FieldWarehouse from "./FieldWarehouse";

interface IPageInvoiceCreateProps {
  onClose?: () => void;
}
interface IFieldRowProps {
  label?: string;
  required?: boolean;
  appendLabel?: React.ReactNode;
}
interface ICommonFieldProps {
  saving: boolean;
}
interface IFieldNumberProps extends ICommonFieldProps {}
interface IFieldDateOfReceiptProps extends ICommonFieldProps {}
interface IFieldVendorProps extends ICommonFieldProps {}
interface IFieldWarehouseProps extends ICommonFieldProps {}
interface IFieldFileProps extends ICommonFieldProps {}
interface IFieldPackageTypeProps extends ICommonFieldProps {}
interface IFieldQuantityPackagesProps extends ICommonFieldProps {}
interface IButtonSaveProps {
  onSave: () => void;
  setSaving: (saving: boolean) => void;
  saving: boolean;
}

export type ButtonSaveFC = React.VFC<IButtonSaveProps>;
export type FieldFileFC = React.VFC<IFieldFileProps>;
export type FieldVendorFC = React.VFC<IFieldVendorProps>;
export type FieldWarehouseFC = React.VFC<IFieldWarehouseProps>;
export type FieldDateOfReceiptFC = React.VFC<IFieldDateOfReceiptProps>;
export type FieldNumberFC = React.VFC<IFieldNumberProps>;
export type FieldRowFC = React.FC<IFieldRowProps>;
export type FieldPackageTypeFC = React.FC<IFieldPackageTypeProps>;
export type PageInvoiceCreateFC = React.VFC<IPageInvoiceCreateProps>;
export type FieldQuantityPackagesFC = React.VFC<IFieldQuantityPackagesProps>;

export enum EnumPackageType {
  PALLET = "Палеты",
  BOX = "Короба",
  NONE = "",
}
